import eventHub from '@/scripts/eventHub';
import store from '@/store';
import vars from './vars';

const state = {
  _score: 0,
  _fuel: 100, // Fuel percentage
  _level: 1,
  _paused: true,
  _gameover: false,

  initialSpeed: 4,
  speed: 4,
  fuelDecreaseSpeed: 0.1,
  hasPowerupOnStage: false,

  // Lerping params
  delayFunction: (a, b, n) => ((1 - n) * a) + (n * b),
  delayFactor: 0.93,

  get score() { return this._score; },
  set score(score) {
    this._score = score;
    store.commit('SET_SCORE', this._score);

    if (this._score !== 0 && this._score % 50 === 0) {
      this.level += 1;
    }
  },
  get fuel() { return this._fuel; },
  set fuel(fuel) {
    this._fuel = Math.max(Math.min(fuel, 100), 0);
    store.commit('SET_FUEL', this._fuel);
  },
  get level() { return this._level; },
  set level(value) {
    this._level = value;
    const l = vars.levels.get(value);
    if (typeof l !== 'undefined') {
      eventHub.$emit('levelchange');
    }
    store.commit('SET_LEVEL', state._level);
  },
  get paused() { return this._paused; },
  set paused(value) {
    this._paused = value;
    if (this._paused) {
      store.commit('SET_MODE', 'paused');
    } else {
      store.commit('SET_MODE', 'playing');
    }
  },
  get gameover() { return this._gameover; },
  set gameover(value) {
    this._gameover = value;
    if (this._gameover) {
      store.commit('SET_MODE', 'gameover');
    }
  },

  reset() {
    this.speed = this.initialSpeed;
    this.level = 1;
    this.score = 0;
    this.fuel = 100;
  },
};

export default state;
